import * as RdxSwitch from '@radix-ui/react-switch';
import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface ISwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: ClassValue;
  'aria-label'?: string;
  id?: string;
  name?: string;
  label?: string;
}

export default function Switch({
  checked,
  onCheckedChange,
  disabled,
  className,
  id,
  name,
  label,
  'aria-label': ariaLabel,
}: ISwitchProps) {
  const switchControl = (
    <RdxSwitch.Root
      id={id}
      name={name}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel ?? label}
      className={cn(
        'inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border-2 shadow-md transition-colors outline-none',
        'bg-grey-100 border-grey-200',
        'dark:bg-surface-input dark:border-border-input',
        'data-[state=checked]:border-green-600 data-[state=checked]:bg-green-600',
        'focus-visible:border-green-600 dark:focus-visible:border-green-400',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
    >
      <RdxSwitch.Thumb
        className={cn(
          'pointer-events-none block h-5 w-5 rounded-full bg-white shadow ring-1 ring-black/5 transition-transform',
          'translate-x-0 data-[state=checked]:translate-x-[20px]',
        )}
      />
    </RdxSwitch.Root>
  );

  if (!label) {
    return switchControl;
  }

  return (
    <label
      htmlFor={id}
      className={cn(
        'flex cursor-pointer items-center gap-3',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      {switchControl}
      <span className="text-text-primary text-sm select-none">{label}</span>
    </label>
  );
}
